import { render } from "./viewintru.vue?vue&type=template&id=0063a98a"
import script from "./viewintru.vue?vue&type=script&lang=js"
export * from "./viewintru.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__